<template>
  <div>
    <p v-if="drug?.cool"><span class="icon icon-snowflake"/> хладагент</p>
    <p v-for="d in (details ?? [])" v-if="d.int_value">
      <template v-if="d.alias === 'order_rate' && +d.int_value !== 1">
        коэфф. закупки <span class="badge badge-success">{{ d.int_value }}</span> <strong>(В фактическое к-во
        вносить
        данные в пересчете на наше к-во таблеток!)</strong>
      </template>
      <template v-if="d.alias === 'oposit_order_rate'">
        фасовка блистеров <span class="badge badge-warning">{{ d.int_value }}</span> <strong>(В фактическое
        к-во
        вносить данные в пересчете на наше к-во таблеток!)</strong>
      </template>
    </p>

    <p v-if="drug?.pack_set > 1">комплект <span
      class="badge badge-info">{{ +drug?.pack_set }}</span> зав.уп.</p>
    <p v-if="drug?.pack_box_comment" class="text-muted">{{ drug.pack_box_comment }}</p>
    <p v-if="drug?.purchase_comment" class="text-muted">{{ drug.purchase_comment }}</p>
    <p v-if="drug?.is_press_can">
                <span class="badge badge-danger">
                 <v-icon name="spray-can"/>
              </span> аэрозоль под давлением
    </p>
    <!--    <div v-if="(detail.extra_data?.selected_expire_dates ?? []).length">-->
    <!--      <i>Указаны сроки годности:</i>-->
    <!--      <strong><span-->
    <!--        v-for="(d,i) in detail.extra_data.selected_expire_dates">{{ i !== 0 ? ', ' : '' }}{{ d.date }}</span></strong>-->
    <!--    </div>-->
  </div>
</template>

<script>

export default {
  props: ['drug', 'details', 'selectedOptions'],
  data() {
    return {
      allOptions: ['en_title', 'cool', 'pack_set', 'is_press_can']
    }
  }
}

</script>

<style scoped>
.icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5BBFDE;
  margin: -3px 4px;
  mask: url(/assets/svg/snowflake-solid.svg);
}
</style>
